import { Box, Typography } from "@mui/material";

export function AIADefinition() {
	return (
		<Box
			sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}
		>
			<Typography variant='body1'>Definição de AIA</Typography>
		</Box>
	);
}
